module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/admin/live-run'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": "LiveRun"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e18418be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/Logo.vue
// module id = 1716
// module chunks = 2